import axios from 'axios'

const API_URL = process.env.GATSBY_ACS_API_URL || ''
const baseURL = API_URL.endsWith('/') ? API_URL.slice(0, -1) : API_URL

// Chord API has 3686 registered states
// Chord now only supports Max 25 per API request
const MAX_STATES_PER_PAGE = 25

export const getStates = async (
  countryId = null,
  itemsPerPage = MAX_STATES_PER_PAGE,
) => {
  try {
    const endpoint = countryId ? `countries/${countryId}/states` : `states`
    const response = []
    let nextPage

    const getAllState = async currentPage => {
      if (!currentPage) {
        return response
      }
      await axios
        .get(`${baseURL}/api/${endpoint}`, {
          params: { per_page: itemsPerPage, page: currentPage },
        })
        .then(r => {
          nextPage = currentPage <= r.data.pages ? currentPage + 1 : null

          response.push(...r.data.states)
        })

      // recursively fetch all states based on total pages
      return getAllState(nextPage)
    }
    // Start by fetching the first page
    return getAllState(1)
  } catch (error) {
    console.error('Axios Error:', error)
    return new Error(error)
  }
}
